import AmenitiesArea from "./AmenitiesArea";

export default AmenitiesArea